import { render, staticRenderFns } from "./turnkey-audience.vue?vue&type=template&id=6fad3ea0&"
import script from "./turnkey-audience.vue?vue&type=script&lang=js&"
export * from "./turnkey-audience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports